import { AxisBottom as VisxAxisBottom, AxisLeft as VisxAxisLeft } from '@visx/axis';
import { GridRows as VisxGridRows } from '@visx/grid';
import { formatNumber } from '@/utils/helpers/formatters';

const GridRows = ({ ...props }: React.ComponentProps<typeof VisxGridRows>) => {
  return (
    <VisxGridRows
      stroke='#1a1a1a'
      style={{ zIndex: -10 }}
      strokeOpacity={0.08}
      {...props}
    />
  );
};

const AxisLeft = ({ ...props }: React.ComponentProps<typeof VisxAxisLeft>) => {
  return (
    <VisxAxisLeft
      numTicks={4}
      tickFormat={(value) => {
        return formatNumber(value as number, null, true);
      }}
      tickLabelProps={{
        fontSize: 12,
        textAnchor: 'end',
        dx: '-4px',
        dy: '6px',
      }}
      {...props}
    />
  );
};

const AxisBottom = ({ ...props }: React.ComponentProps<typeof VisxAxisBottom>) => {
  return (
    <VisxAxisBottom
      tickLabelProps={{
        fontSize: 10,
        textAnchor: 'start',
        dy: '2px',
      }}
      {...props}
    />
  );
};

export { AxisBottom, AxisLeft, GridRows };
